import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import { AuthProvider } from './context/AuthContext';
import { CartProvider } from './context/CartContext';
import { TranslationProvider } from './context/TranslationContext';
import Navbar from './components/Navbar';
import Footer from './components/Footer';
import CookiesBanner from './components/CookiesBanner';
import Home from './pages/Home';
import Products from './pages/Products';
import BusinessOrdering from './pages/BusinessOrdering';
import ProductDetail from './pages/ProductDetail';
import Cart from './pages/Cart';
import CheckoutConfirm from './pages/CheckoutConfirm';
import CheckoutSuccess from './pages/CheckoutSuccess';
import UserManagement from './components/UserManagement';
import Shipping from './pages/Shipping';
import About from './pages/About';
import Contact from './pages/Contact';
import Legal from './pages/Legal';
import Login from './pages/Login';
import Settings from './pages/Settings';
import Gallery from './pages/Gallery';
import MyOrders from './pages/MyOrders';
import NotFound from './pages/NotFound';
import GlobalNotice from './components/GlobalNotice';
import HolidayBanner from './components/HolidayBanner';
import AdminOrders from './components/AdminOrders';
import AdminCustomerPrices from './components/AdminCustomerPrices';
import AdminPickupLocations from './components/AdminPickupLocations';
import AdminPickupBookings from './components/AdminPickupBookings';
import AdminProducts from './components/AdminProducts';
import AdminCoupons from './components/AdminCoupons';
import AdminInventory from './components/AdminInventory';
import AdminLandingPages from './components/AdminLandingPages';
import AdminMediaCenter from './components/AdminMediaCenter';
import AdminAccounting from './components/AdminAccounting';
import AdminAccountingDocument from './components/AdminAccountingDocument';
import AdminVatReport from './components/AdminVatReport';
import AdminBusinessRequests from './components/AdminBusinessRequests';
import AdminSettings from './pages/AdminSettings';
import AdminEmailTemplates from './pages/AdminEmailTemplates';
import DashboardLayout from './layouts/DashboardLayout';

import GDPR from './pages/GDPR';
import Privacy from './pages/Privacy';
import TOS from './pages/TOS';

// import ValentinesHome from './pages/ValentinesHome';
// import HoliHome from './pages/HoliHome';

import './App.css';

export default function App() {
  return (
    // <HoliHome />
    <AuthProvider>
      <TranslationProvider>
        <CartProvider>
          <Router>
            <div className="App">
              <a href="#main-content" className="skip-link">
                Skip to main content
              </a>
          <Navbar />
          <HolidayBanner />
          <GlobalNotice />

              <main id="main-content" className="main-content" tabIndex={-1}>
                <Routes>
                  <Route path="/" element={<Home />} />
                  <Route path="/products" element={<Products />} />
                  <Route path="/products/:productCode" element={<ProductDetail />} />
                  <Route path="/shipping" element={<Shipping />} />
                  <Route path="/bulk-order" element={<BusinessOrdering />} />
                  <Route path="/about" element={<About />} />
                  <Route path="/contact" element={<Contact />} />
                  <Route path="/gallery" element={<Gallery />} />
                  <Route path="/legal" element={<Legal />} />
                  <Route path="/login" element={<Login />} />
                  <Route path="/cart" element={<Cart />} />
                  <Route path="/checkout/confirm" element={<CheckoutConfirm />} />
                  <Route path="/checkout/success" element={<CheckoutSuccess />} />

                  {/* Migrated Dashboard Layout Routes */}
                  <Route path="/dashboard" element={<DashboardLayout />}>
                    {/* Users */}
                    <Route index element={<MyOrders />} />
                    <Route path="orders" element={<MyOrders />} />
                    <Route path="settings" element={<Settings />} />

                    {/* Admins */}
                    <Route path="products" element={<AdminProducts />} />
                    <Route path="inventory" element={<AdminInventory />} />
                    <Route path="pricing" element={<AdminCustomerPrices />} />
                    <Route path="coupons" element={<AdminCoupons />} />
                    <Route path="customers" element={<UserManagement />} />
                    <Route path="admin-orders" element={<AdminOrders />} />
                    <Route path="pickup-locations" element={<AdminPickupLocations />} />
                    <Route path="pickup-bookings" element={<AdminPickupBookings />} />
                    <Route path="landing-page" element={<AdminLandingPages />} />
                    <Route path="media" element={<AdminMediaCenter />} />
                    <Route path="accounting" element={<AdminAccounting />} />
                    <Route path="accounting/:id" element={<AdminAccountingDocument />} />
                    <Route path="accounting/vat-report" element={<AdminVatReport />} />
                    <Route path="business-requests" element={<AdminBusinessRequests />} />
                    <Route path="admin-settings" element={<AdminSettings />} />
                    <Route path="email-templates" element={<AdminEmailTemplates />} />
                  </Route>

                  <Route path="/gdpr" element={<GDPR />} />
                  <Route path="/privacy" element={<Privacy />} />
                  <Route path="/tos" element={<TOS />} />
                  
                  <Route path="*" element={<NotFound />} />
                </Routes>
              </main>

              <Footer />
              <CookiesBanner />
            </div>
          </Router>
        </CartProvider>
      </TranslationProvider>
    </AuthProvider>
  );
}